<template>
  <div
    class="logo-divider"
    :class="{ 'logo-divider-small': $vuetify.breakpoint.sm || $vuetify.breakpoint.md }"
    v-if="$vuetify.breakpoint.smAndUp"
  ></div>
</template>

<script>
export default {
  name: 'HeaderLogoDivider',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
.logo-divider {
  height: 40px;
  border-left: 1px solid rgba(0, 0, 0, 0.5);
  margin: 0 16px;
}
.logo-divider-small {
  height: 26px;
}
</style>
